import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { catchError, Observable, of, take } from 'rxjs';
import {
  ApiResponseTicket,
  PaginatedResponse,
  Ticket,
  TicketAttachment,
  TicketDetail,
  TicketSupply,
  TicketTemplate,
  WorkFlowProject,
} from '../models/ticket-model/tiket.model';
import { ApiResponseCatalog, WorkFlow } from '../models/ticket-model/catalogs-model';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getTicketDetail(id: number | string): Observable<ApiResponseTicket<TicketDetail> | null> {
    return this.http
      .get<ApiResponseTicket<TicketDetail>>(this.URL_API + `/api/Ticket/Detail/${id}`)
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public ticketCreate(body: {
    CustomerId: number;
    WorkFlowId: number | string;
    LocationId: number | string;
    Supplies: { Id: number | string; Quantity: number }[];
    Latitude: string | number;
    Longitude: string | number;
    StreetName: string;
  }): Observable<any | null> {
    return this.http.post<any>(`${this.URL_API}/api/WorkFlowProject/Create`, body).pipe(
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getWorkFlow(): Observable<ApiResponseCatalog<WorkFlow[]> | null> {
    return this.http
      .get<ApiResponseCatalog<WorkFlow[]>>(this.URL_API + `/api/WorkFlow/List`, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getWorkFlowProject(params: {
    LocationId: number | string;
    WorkFlowId: number | string;
  }): Observable<ApiResponseCatalog<WorkFlowProject[]> | null> {
    const paramsAux = this.generalService.buildParamsEncoder(params);
    return this.http
      .get<
        ApiResponseCatalog<WorkFlowProject[]>
      >(this.URL_API + `/api/WorkFlowProject/List`, { params: paramsAux })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getTickets(LocationKey: string): Observable<ApiResponseCatalog<TicketDetail[]> | null> {
    return this.http
      .get<
        ApiResponseCatalog<TicketDetail[]>
      >(this.URL_API + `/api/Ticket/List?LocationKey=${LocationKey}`, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getOpenTickets(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
  }): Observable<ApiResponseCatalog<PaginatedResponse<Ticket>> | null> {
    const paramsAux = this.generalService.buildParamsEncoder(params);
    return this.http
      .get<
        ApiResponseCatalog<PaginatedResponse<Ticket>>
      >(this.URL_API + `/api/OpenTicket/Paged`, { params: paramsAux })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public getClosedTicket(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
  }): Observable<ApiResponseCatalog<PaginatedResponse<Ticket>> | null> {
    const paramsAux = this.generalService.buildParamsEncoder(params);
    return this.http
      .get<
        ApiResponseCatalog<PaginatedResponse<Ticket>>
      >(this.URL_API + `/api/ClosedTicket/Paged`, { params: paramsAux })
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  getPositionEngineer(
    id: number | string,
  ): Observable<ApiResponseCatalog<{ Latitude: string; Longitude: string }> | null> {
    return this.http
      .get<
        ApiResponseCatalog<{ Latitude: string; Longitude: string }>
      >(this.URL_API + `/api/Engineer/Position/${id}`, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }

  public ticketPendingSupply(
    ticketId: number | string,
  ): Observable<ApiResponseCatalog<TicketSupply[]> | null> {
    return this.http
      .get<
        ApiResponseCatalog<TicketSupply[]>
      >(this.URL_API + '/api/TicketPendingSupply/List?ticketId=' + ticketId, {})
      .pipe(
        take(1),
        catchError(() => {
          return of(null);
        }),
      );
  }
}
